<div class="panel" [class.faded]="bg == 'faded'" [class.transparent]="bg == 'transparent'" [class.padded-v]="paddedV" [class.padded-h]="paddedH">
  @if (contentHeader) {
    <app-content-header [padded]="!paddedH" [title]="contentHeader" [large]="large" [action]="action" (actionClick)="actionClicked()" />
  }
  <ng-content></ng-content>
</div>